import React, { useEffect, useState } from "react";
import { RightCollapseIcon, SpinnerIcon } from "../../../Static/icons/iconshere";
import Select from "react-select";
import shortUUID from "short-uuid";
import { FileUploader } from "react-drag-drop-files";
import draftToHtml from "draftjs-to-html";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { useSelector } from "react-redux";
import axios from "axios";
import apiClient from "../../../apiClient";
import {
  FETCH_DYNAMIC_INFO,
  FETCH_DYNAMIC_MODULES,
  SAVE_DYNAMIC_MODULE_STEPS,
  UPDATE_DYNAMIC_MODULE,
} from "../../../apiClient/apiEndpoints";
import KeyValueInput from "./KeyValueInput";
import { useParams } from "react-router-dom";
import DynamicModuleTable from "./DynamicModuleTable";
import { generateShortUUID, imageFileTypes } from "../../../utils/constants";
import Progress from "react-progressbar";

const voiceOverFileTypes = ["MP3", "WAV", "OGG", "AAC", "M4A"];
const imageOverFileTypes = ["PNG", "JPEG", "JPG"];

const formatFileSize = (bytes) => {
  if (bytes >= 1048576) {
    return (bytes / 1048576).toFixed(2) + " MB";
  }
  if (bytes >= 1024) {
    return (bytes / 1024).toFixed(2) + " KB";
  }
  return bytes + " bytes";
};

const stepTypeOptions = [
  {
    label: "Acknowledge",
    value: "POPUP_WITH_BUTTON",
  },
  {
    label: "Acknowledge With Timer",
    value: "POPUP_WITH_TIMER",
  },
  {
    label: "Interaction Type",
    value: "INTERACTION",
  },
];

const addActionOptions = [
  { label: "None", value: "NONE" },
  { label: "Teleport", value: "TELEPORT" },
];

const scenarioBuilderStepLanguages = [
  { value: "english", label: "English" },
  { value: "hindi", label: "Hindi" },
  { value: "bengali", label: "Bengali" },
  { value: "marathi", label: "Marathi" },
  { value: "gujarati", label: "Gujarati" },
  { value: "tamil", label: "Tamil" },
  { value: "telugu", label: "Telugu" },
  { value: "kannada", label: "Kannada" },
  { value: "malayalam", label: "Malayalam" },
];

const emptyStepsObject = {
  id: generateShortUUID(),
  title: "",
  description: "",
  type: "",
  message: "",
  targetLocation: "",
  popupMessage: "",
  popupDuration: "",
  popupButton: "",
  conditions: [
    {
      id: generateShortUUID(),
      key: "",
      value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
    },
  ],
  onTargetMessage: "",
  onTarget: [
    {
      id: generateShortUUID(),
      key: "",
      value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
    },
  ],
  stepEnd: [
    {
      id: generateShortUUID(),
      key: "",
      value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
    },
  ],
  endResults: [
    {
      id: generateShortUUID(),
      key: "",
      value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
    },
  ],

  actionType: addActionOptions[0],
  playerLandingPosition: "",

  voice: {
    file: null,
    voiceover: null,
    filename: "",
    progress: 0,
  },

  image: {
    file: null,
    imagePath: null,
    filename: "",
    progress: 0,
  }

};

const checkFalseyValues = (slug) => {
  if (slug === 0 || slug === false) {
    return false;
  }
  return !slug;
};

const AddDynamicModule = () => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const { uuid: environmentId, moduleId } = useParams();
  const [moduleData, setModuleData] = useState({});
  const UNO_URL = configData?.config?.UNO_URL;
  const [moduleDetails, setModuleDetails] = useState({
    name: moduleData?.name || "",
    description: moduleData?.versions?.[0]?.data?.description || "",
    thumbnail: moduleData?.versions?.[0]?.data?.thumbnail || null,
  });
  const [showProgress, setShowProgress] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formLoading, setFormLoading] = useState({
    basic: false,
    steps: false,
  });
  const [interactiveOptionList, setInteractiveOptionList] = useState([]);
  const [interactiveAnimationMapping, setInteractiveAnimationMapping] = useState({});
  const [hotspotList, setHotspotList] = useState([]);
  const [fileError, setFileError] = useState(null);
  const [formError, setFormError] = useState({});
  const [visibleSteps, setVisibleSteps] = useState([]);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [stepsList, setStepsList] = useState([emptyStepsObject]);
  const [playerSpot, setPlayerSpot] = useState({});
  const [playerSpotError, setPlayerSpotError] = useState(false);
  const [visibleStepComponents, setVisibleStepComponents] = useState({});
  const [showModuleInitialPoints, setShowModuleInitialPoints] = useState(false);
  const [initialization, setInitialization] = useState([
    {
      id: generateShortUUID(),
      key: "",
      value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
    },
  ]);
  const [selectedModuleLanguage, setSelectedModuleLanguage] = useState("english");
  const [enableLanguageSelection, setEnableLanguageSelection] = useState(false);

  // Add a new initialization object
  const onAddButtonClick = () => {
    const newColumn = {
      id: generateShortUUID(),
      key: "",
      value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
    };
    setInitialization((prev) => [...prev, newColumn]);
  };

  // Remove the selected initialization object
  const onRemoveClick = (id) => {
    setInitialization((prev) => prev.filter((item) => item.id !== id));
  };

  // Fetch the basic data of module
  const fetchModuleData = async () => {
    const query = { moduleId };
    const res = await apiClient.get(`${UNO_URL}${FETCH_DYNAMIC_MODULES}/${environmentId}`, { params: query });
    setModuleData(res[0]);
  };

  // Add and remove step form fields
  const onNewStepAddClick = (targetIndex) =>
    setStepsList((prev) => {
      const prevCopy = [...prev];
      const newStep = {
        ...emptyStepsObject,
        id: generateShortUUID(),
        conditions: [
          {
            id: generateShortUUID(),
            key: "",
            value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
          },
        ],
        onTarget: [
          {
            id: generateShortUUID(),
            key: "",
            value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
          },
        ],
        stepEnd: [
          {
            id: generateShortUUID(),
            key: "",
            value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
          },
        ],
        endResults: [
          {
            id: generateShortUUID(),
            key: "",
            value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
          },
        ],
      };
      prevCopy.splice(targetIndex, 0, newStep);
      return prevCopy;
    });
  const onRemoveStepsClick = (id) => setStepsList((prev) => prev.filter((item) => item.id !== id));

  // Handle intialization's object and value change
  const onChangeHandler = (id, name, value, valueType, valueObjectKey) => {
    setInitialization((prev) => {
      const changedData = prev.map((item) => {
        if (item.id === id) {
          if (name === "key") {
            item[name] = value;
          } else {
            item[name] = { ...(item[name] || {}), [valueObjectKey]: value };
          }
          return item;
        }
        return item;
      });
      return changedData;
    });
  };

  // Show/hide the selected step form
  const toggleStepVisibility = (id) => {
    const find = visibleSteps.find((item) => item === id);
    if (!find) {
      setVisibleSteps((prev) => [...prev, id]);
    } else {
      setVisibleSteps((prev) => prev.filter((i) => i !== id));
    }
  };

  // For the description field
  const handleEditorChange = (event) => {
    setEditorState(event);
    setModuleDetails((prev) => ({ ...prev, description: "" + draftToHtml(convertToRaw(event.getCurrentContent())) }));
  };
  const removeThumbnail = () => {
    setModuleDetails((prev) => ({ ...prev, thumbnail: "" }));
  };

  const handleImageUpload = async (file) => {
    try {
      if (!file) {
        return;
      }
      setFileError(null);
      setShowProgress(true);
      const formData = new FormData();
      formData.append("file", file);

      const res = await axios.post(`${UNO_URL}/api/resource/upload/thumbnail/${moduleData?.uuid}`, formData, {
        headers: {
          "Content-Type ": "multipart/form-data",
          Authorization: `Bearer ${userData?.token}`,
        },
      });
      setModuleDetails((prev) => ({ ...prev, thumbnail: res?.data?.url }));
      setShowProgress(false);
    } catch (error) {
      console.log(error);
      setModuleDetails((prev) => ({ ...prev, thumbnail: null }));
    } finally {
      setTimeout(() => {
        setFileError(null);
      }, 3500);
    }
  };

  // fetches the interactive object and hotspot list and creates category mapping of interactive objects
  const fetchDynamicInfo = async () => {
    const res = await apiClient.get(`${UNO_URL}${FETCH_DYNAMIC_INFO}/${environmentId}`);
    const objectAnimationMapping = {};
    const options =
      res?.versions?.[0]?.data?.interactableObjects?.map((item) => {
        objectAnimationMapping[item.id] = item.animationData;
        return {
          label: `${item.id} - ${item.value}`,
          value: item.id,
        };
      }) || [];
    setInteractiveAnimationMapping(objectAnimationMapping);
    setInteractiveOptionList(options);
    setHotspotList(res?.versions?.[0]?.data?.hotspots?.map((item) => ({ label: item.value, value: item.id })) || []);
  };

  // handles the change in step form fields (without the key value pair inputs)
  const stepsChangeHandler = (id, name, value) => {
    setStepsList((prev) => {
      const changedData = prev.map((item) => {
        if (item.id === id) {
          switch (name) {
            case "title":
              !value
                ? setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: true } }))
                : setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: false } }));
              break;
            // case "description":
            //   !value
            //     ? setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: true } }))
            //     : setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: false } }));
            //   break;
            case "type":
              !value
                ? setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: true } }))
                : setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: false } }));
              break;
            case "popupButton":
              if (item.type?.value === "POPUP_WITH_BUTTON") {
                !value
                  ? setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: true } }))
                  : setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: false } }));
              }
              break;
            case "popupDuration":
              if (item.type?.value === "POPUP_WITH_TIMER") {
                !value
                  ? setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: true } }))
                  : setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: false } }));
              }
              break;
            case "actionType":
              if (value?.value !== "TELEPORT") {
                item.playerLandingPosition = "";
              }
              break;
            // case "popupMessage":
            //   !value
            //     ? setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: true } }))
            //     : setFormError((prev) => ({ ...prev, [id]: { ...prev[id], [name]: false } }));
            //   break;
            default:
          }
          item[name] = value;
          return item;
        }
        return item;
      });
      return changedData;
    });
  };

  const handleStepImageUpload = async (stepId, file) => {
    if (!file) return;

    setStepsList((prev) =>
      prev.map((item) =>
        item.id === stepId ? {
          ...item,
          image: {
            ...(item?.image || {}),
            file: file,
            imagePath: "",
            filename: file.name,
            progress: 0,
          }
        }
          :
          item
      )
    );

    try {
      const formData = new FormData();
      formData.append("file", file);

      let { data } = await axios.post(`${UNO_URL}/api/resource/upload/scenario/image/${moduleData?.uuid}`, formData, {
        headers: {
          "Content-Type ": "multipart/form-data",
          Authorization: `Bearer ${userData?.token}`,
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
          if (progress < 100) {
            setStepsList((prev) =>
              prev.map((item) =>
                item.id === stepId ? {
                  ...item,
                  image: {
                    ...item.image,
                    progress: progress,
                  }
                } : item
              )
            );
          }
        },
      });

      setStepsList((prev) =>
        prev.map((item) =>
          item.id === stepId ? {
            ...item,
            image: {
              ...item.image,
              imagePath: data.url,
              progress: 100,
            }
          }
            :
            item
        )
      );
    } catch (error) {
      console.log(error);
      setStepsList((prev) =>
        prev.map((item) =>
          item.id === stepId ? {
            ...item,
            image: {
              file: null,
              imagePath: null,
              filename: "",
              progress: 0,
            }
          } : item
        )
      );
    }
  };

  const handleVoiceOverUpload = async (stepId, file) => {
    if (!file) return;

    setStepsList((prev) =>
      prev.map((item) =>
        item.id === stepId ? {
          ...item,
          voice: {
            ...(item?.voice || {}),
            file: file,
            voiceover: "",
            filename: file.name,
            progress: 0,
          }
        }
          :
          item
      )
    );

    try {
      const formData = new FormData();
      formData.append("file", file);

      let { data } = await axios.post(`${UNO_URL}/api/resource/upload/scenario/voice/${moduleData?.uuid}`, formData, {
        headers: {
          "Content-Type ": "multipart/form-data",
          Authorization: `Bearer ${userData?.token}`,
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
          if (progress < 100) {
            setStepsList((prev) =>
              prev.map((item) =>
                item.id === stepId ? {
                  ...item,
                  voice: {
                    ...item.voice,
                    progress: progress,
                  }
                } : item
              )
            );
          }
        },
      });

      setStepsList((prev) =>
        prev.map((item) =>
          item.id === stepId ? {
            ...item,
            voice: {
              ...item.voice,
              voiceover: data.url,
              progress: 100,
            }
          }
            :
            item
        )
      );
    } catch (error) {
      console.log(error);
      setStepsList((prev) =>
        prev.map((item) =>
          item.id === stepId ? {
            ...item,
            voice: {
              file: null,
              voiceover: null,
              filename: "",
              progress: 0,
            }
          } : item
        )
      );
    }
  };

  const handleVoiceOverRemove = (stepId) => {
    setStepsList((prev) =>
      prev.map((item) => (item.id === stepId ? {
        ...item,
        voice: {
          file: null,
          voiceover: null,
          filename: "",
          progress: 0,
        }
      } : item))
    );
  };

  const handleImageRemove = (stepId) => {
    setStepsList((prev) =>
      prev.map((item) => (item.id === stepId ? {
        ...item,
        image: {
          file: null,
          imagePath: null,
          filename: "",
          progress: 0,
        }
      } : item))
    );
  };

  const handleSaveBasicDetails = async () => {
    try {
      setFormLoading((prev) => ({ ...prev, basic: true }));
      const payload = {
        thumbnail: moduleDetails?.thumbnail,
        description: moduleDetails?.description,
        name: moduleDetails?.name,
      };
      await apiClient.post(`${UNO_URL}${UPDATE_DYNAMIC_MODULE}/${moduleData?.uuid}`, payload);
    } catch (error) {
      console.log(error);
    } finally {
      setFormLoading((prev) => ({ ...prev, basic: false }));
    }
  };

  const handleAddInitialCondition = (stepId) => {
    const newColumn = {
      id: generateShortUUID(),
      key: "",
      value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
    };
    setStepsList((prev) => {
      const changedData = prev.map((item) => {
        if (item.id === stepId) {
          item.conditions = [...item.conditions, newColumn];
          return item;
        } else {
          return item;
        }
      });
      return changedData;
    });
  };

  const handleRemoveInitialCondition = (stepId, conditionId) => {
    setStepsList((prev) => {
      const changedData = prev.map((item) => {
        if (item.id === stepId) {
          item.conditions = item.conditions.filter((condition) => condition.id !== conditionId);
          return item;
        } else {
          return item;
        }
      });
      return changedData;
    });
  };

  const handleAddOnTarget = (stepId) => {
    const newColumn = {
      id: generateShortUUID(),
      key: "",
      value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
    };
    setStepsList((prev) => {
      const changedData = prev.map((item) => {
        if (item.id === stepId) {
          item.onTarget = [...item.onTarget, newColumn];
          return item;
        } else {
          return item;
        }
      });
      return changedData;
    });
  };

  const handleRemoveOnTarget = (stepId, targetId) => {
    setStepsList((prev) => {
      const changedData = prev.map((item) => {
        if (item.id === stepId) {
          item.onTarget = item.onTarget.filter((target) => target.id !== targetId);
          return item;
        } else {
          return item;
        }
      });
      return changedData;
    });
  };

  const handleAddStepEnd = (stepId) => {
    const newColumn = {
      id: generateShortUUID(),
      key: "",
      value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
    };
    setStepsList((prev) => {
      const changedData = prev.map((item) => {
        if (item.id === stepId) {
          item.stepEnd = [...item.stepEnd, newColumn];
          return item;
        } else {
          return item;
        }
      });
      return changedData;
    });
  };

  const handleRemoveStepEnd = (stepId, stepEndId) => {
    setStepsList((prev) => {
      const changedData = prev.map((item) => {
        if (item.id === stepId) {
          item.stepEnd = item.stepEnd.filter((s) => s.id !== stepEndId);
          return item;
        } else {
          return item;
        }
      });
      return changedData;
    });
  };

  const handleAddEndResult = (stepId) => {
    const newColumn = {
      id: generateShortUUID(),
      key: "",
      value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
    };
    setStepsList((prev) => {
      const changedData = prev.map((item) => {
        if (item.id === stepId) {
          item.endResults = [...item.endResults, newColumn];
          return item;
        } else {
          return item;
        }
      });
      return changedData;
    });
  };

  const handleRemoveEndResult = (stepId, endResultId) => {
    setStepsList((prev) => {
      const changedData = prev.map((item) => {
        if (item.id === stepId) {
          item.endResults = item.endResults.filter((s) => s.id !== endResultId);
          return item;
        } else {
          return item;
        }
      });
      return changedData;
    });
  };

  const handleStepsChange = (stepObjKeyName, stepId, id, key, value, valueType, valueObjectKey) => {
    // if (key === "key" && !value) {
    //   setFormError((prev) => ({ ...prev, [id]: { ...prev[id], key: true } }));
    // } else if (key === "key") {
    //   setFormError((prev) => ({ ...prev, [id]: { ...prev[id], key: false } }));
    // } else if (
    //   key === "value" &&
    //   valueType !== "float" &&
    //   (!String(value)?.trim() || Number(value) < 0 || Number(value) > 100)
    // ) {
    //   setFormError((prev) => ({ ...prev, [id]: { ...prev[id], value: true } }));
    // } else if (key === "value") {
    //   setFormError((prev) => ({ ...prev, [id]: { ...prev[id], value: false } }));
    // }

    setStepsList((prev) => {
      const changedData = prev.map((step) => {
        if (step.id === stepId) {
          const newData = step[stepObjKeyName].map((item) => {
            if (item.id === id) {
              if (key === "key") {
                item[key] = value;
              } else {
                item[key] = { ...(item[key] || {}), [valueObjectKey]: value };
              }
              return item;
            } else {
              return item;
            }
          });
          step[stepObjKeyName] = newData;
          return step;
        } else {
          return step;
        }
      });
      return changedData;
    });
  };

  const isPayloadIncorrect = (list) => {
    const errorStatus = list.reduce((acc, { id, key, value }) => {
      let flag = false;
      if (!key && checkFalseyValues(value)) {
        setFormError((prev) => ({ ...prev, [id]: { ...prev[id], key: true, value: true } }));
        flag = flag || true;
      } else if (!key && value) {
        setFormError((prev) => ({ ...prev, [id]: { ...prev[id], key: true } }));
        flag = flag || true;
      } else if (key?.value === "percent" && (!String(value)?.trim() || Number(value) < 0 || Number(value) > 100)) {
        setFormError((prev) => ({ ...prev, [id]: { ...prev[id], value: true } }));
        flag = flag || true;
      } else if (key && checkFalseyValues(value)) {
        setFormError((prev) => ({ ...prev, [id]: { ...prev[id], value: true } }));
        flag = flag || true;
      }
      return acc || flag;
    }, false);
    return errorStatus;
  };

  const checkBasicPayload = (list) => {
    !playerSpot ? setPlayerSpotError(true) : setPlayerSpotError(false);
    const errorStatus = list.reduce((acc, listItem) => {
      let flag = false;
      Object.keys(listItem).forEach((item) => {
        switch (item) {
          case "title":
            if (!listItem[item]) {
              setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: true } }));
              flag = flag || true;
            } else {
              setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: false } }));
              flag = flag || false;
            }
            break;
          case "description":
            if (!listItem[item]) {
              setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: true } }));
              flag = flag || true;
            } else {
              setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: false } }));
              flag = flag || false;
            }
            break;
          case "type":
            if (!listItem[item]) {
              setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: true } }));
              flag = flag || true;
            } else {
              setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: false } }));
              flag = flag || false;
            }
            break;
          case "popupButton":
            if (listItem?.type?.value === "POPUP_WITH_BUTTON") {
              if (!listItem[item]) {
                setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: true } }));
                flag = flag || true;
              } else {
                setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: false } }));
                flag = flag || false;
              }
            }
            break;
          case "popupDuration":
            if (listItem?.type?.value === "POPUP_WITH_TIMER") {
              if (!listItem[item]) {
                setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: true } }));
                flag = flag || true;
              } else {
                setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: false } }));
                flag = flag || false;
              }
            }
            break;
          case "popupMessage":
            if (!listItem[item]) {
              setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: true } }));
              flag = flag || true;
            } else {
              setFormError((prev) => ({ ...prev, [listItem.id]: { ...prev[listItem.id], [item]: false } }));
              flag = flag || false;
            }
            break;
          default:
        }
      });
      return acc || flag;
    }, false);
    return errorStatus;
  };

  const handleSaveStepsAndInitialization = async () => {
    try {

      setFormLoading((prev) => ({ ...prev, steps: true }));

      let payloadArray = [...initialization];

      const basicPayloadArray = [];

      stepsList?.forEach((value) => {

        basicPayloadArray.push({
          id: value.id,
          title: value.title,
          description: value.description,
          type: value.type,
          popupButton: value.popupButton,
          popupDuration: value.popupDuration,
          popupMessage: value.popupMessage,
        });
        payloadArray = [...payloadArray, ...value.conditions, ...value.onTarget, ...value.stepEnd, ...value.endResults];

      });

      const payload = {
        enableLanguage: enableLanguageSelection,
        language: enableLanguageSelection ? selectedModuleLanguage : "english",
        initial: {
          location: playerSpot?.value || "",
          conditions: initialization.map((item) => {
            return {
              key: item.key?.value || "",
              // value: item?.value ? Number(item.value) : 0,
              value: {
                expectedAnimationState: Number(item?.value?.expectedAnimationState || 0),
                animationFloatValue: Number(item?.value?.animationFloatValue || 0),
                isHighlight: item?.value?.isHighlight || false,
              },
            };
          }),
        },

        steps: stepsList.map((step) => {
          return {
            title: step?.title || "",
            description: step?.description || "",
            message: step?.message || "",
            type: step?.type?.value || "",
            popupMessage: step?.popupMessage || "",
            popupDuration: step?.popupDuration ? Number(step.popupDuration) : 0,
            popupButton: step?.popupButton || "",
            onTargetMessage: step?.onTargetMessage || "",
            targetLocation: step?.targetLocation?.value || "",
            conditions: step?.conditions.map((item) => {
              return {
                key: item.key?.value || "",
                // value: item?.value ? Number(item.value) : 0,
                value: {
                  expectedAnimationState: Number(item?.value?.expectedAnimationState || 0),
                  animationFloatValue: Number(item?.value?.animationFloatValue || 0),
                  isHighlight: item?.value?.isHighlight || false,
                },
              };
            }),
            onTarget: step?.onTarget.map((item) => {
              return {
                key: item.key?.value || "",
                // value: item?.value ? Number(item.value) : 0,
                value: {
                  expectedAnimationState: Number(item?.value?.expectedAnimationState || 0),
                  animationFloatValue: Number(item?.value?.animationFloatValue || 0),
                  isHighlight: item?.value?.isHighlight || false,
                },
              };
            }),
            stepEnd: step?.stepEnd.map((item) => {
              return {
                key: item.key?.value || "",
                // value: item?.value ? Number(item.value) : 0,
                value: {
                  expectedAnimationState: Number(item?.value?.expectedAnimationState || 0),
                  animationFloatValue: Number(item?.value?.animationFloatValue || 0),
                  isHighlight: item?.value?.isHighlight || false,
                },
              };
            }),
            endResults: step?.endResults.map((item) => {
              return {
                key: item.key?.value || "",
                // value: item?.value ? Number(item.value) : 0,
                value: {
                  expectedAnimationState: Number(item?.value?.expectedAnimationState || 0),
                  animationFloatValue: Number(item?.value?.animationFloatValue || 0),
                  isHighlight: item?.value?.isHighlight || false,
                },
              };
            }),

            actionType: step?.actionType?.value || "",
            playerLandingPosition: step?.playerLandingPosition?.value || "",
            voice: {
              voiceover: step?.voice?.voiceover,
              filename: step?.voice?.filename
            },
            image: {
              imagePath: step?.image?.imagePath,
              filename: step?.image?.filename
            }
          };
        }),
      };

      await apiClient.post(`${UNO_URL}${SAVE_DYNAMIC_MODULE_STEPS}/${moduleData.uuid}`, payload);

    } catch (error) {

      console.log(error);
    } finally {
      setFormLoading((prev) => ({ ...prev, steps: false }));
    }
  };

  const findInList = (optionList, value) => optionList.find((item) => item.value === value);

  useEffect(() => {
    if (!loading && moduleData?.uuid) {
      setEditorState(
        EditorState.createWithContent(
          ContentState.createFromBlockArray(convertFromHTML(moduleData?.versions?.[0]?.data?.description || ""))
        )
      );
      setModuleDetails({
        name: moduleData?.name || "",
        description: moduleData?.versions?.[0]?.data?.description || "",
        thumbnail: moduleData?.versions?.[0]?.data?.thumbnail || null,
      });

      const initAndStepData = moduleData?.children?.[0]?.versions?.[0]?.data;
      setEnableLanguageSelection(Boolean(initAndStepData?.enableLanguage));
      setSelectedModuleLanguage(initAndStepData?.language || "english");
      setPlayerSpot(findInList(hotspotList, initAndStepData?.initial?.location));

      const findInitializationData = initAndStepData?.initial?.conditions?.map((item) => ({
        id: generateShortUUID(),
        key: findInList(interactiveOptionList, item.key),
        value: item.value || { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
      }));

      setInitialization(
        findInitializationData || [
          {
            id: generateShortUUID(),
            key: "",
            value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
          },
        ]
      );

      const findStepsListData = initAndStepData?.steps?.map((item) => {
        return {
          id: generateShortUUID(),
          title: item.title || "",
          description: item.title || "",
          message: item.message || "",
          type: findInList(stepTypeOptions, item.type),
          targetLocation: findInList(hotspotList, item.targetLocation),
          popupMessage: item.popupMessage || "",
          popupDuration: item.popupDuration || "",
          popupButton: item.popupButton || "",
          conditions: item.conditions.map((condition) => ({
            id: generateShortUUID(),
            key: findInList(interactiveOptionList, condition.key),
            value: condition.value || { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
          })) || [
              {
                id: generateShortUUID(),
                key: "",
                value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
              },
            ],
          onTargetMessage: item.onTargetMessage || "",
          onTarget: item.onTarget.map((target) => ({
            id: generateShortUUID(),
            key: findInList(interactiveOptionList, target.key),
            value: target.value || { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
          })) || [
              {
                id: generateShortUUID(),
                key: "",
                value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
              },
            ],
          stepEnd: item.stepEnd.map((stepEnd) => ({
            id: generateShortUUID(),
            key: findInList(interactiveOptionList, stepEnd.key),
            value: stepEnd.value || { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
          })) || [
              {
                id: generateShortUUID(),
                key: "",
                value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
              },
            ],
          endResults: item.endResults?.map((endResult) => ({
            id: generateShortUUID(),
            key: findInList(interactiveOptionList, endResult.key),
            value: endResult.value || { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
          })) || [
              {
                id: generateShortUUID(),
                key: "",
                value: { expectedAnimationState: "", animationFloatValue: "", isHighlight: true },
              },
            ],

          actionType: findInList(addActionOptions, item.actionType) || addActionOptions[0],
          playerLandingPosition: findInList(hotspotList, item.playerLandingPosition),

          voice: {
            file: null,
            voiceover: item?.voice?.voiceover || "",
            filename: item?.voice?.filename || "",
            progress: 0,
          },

          image: {
            file: null,
            imagePath: item?.image?.imagePath || "",
            filename: item?.image?.filename || "",
            progress: 0,
          }

        };
      });

      setStepsList(findStepsListData || [emptyStepsObject]);
    }
  }, [moduleData, loading]);

  const initializePage = async () => {
    await Promise.all([fetchDynamicInfo(), fetchModuleData()]);
  };

  const toggleStepComponentsVisibility = (id, compName) => {
    setVisibleStepComponents((prev) => ({
      ...prev,
      [id]: { ...(prev?.[id] || {}), [compName]: !prev?.[id]?.[compName] },
    }));
  };

  const toggleInitialPointsVisibility = () => setShowModuleInitialPoints((prev) => !prev);

  useEffect(() => {
    setLoading(true);
    initializePage();
    setLoading(false);
  }, []);

  return loading ? (
    <> Data is fetching... </>
  ) : (
    <>
      <div className="detailspage container-fluid">
        <div className="mainbox">
          <div className="row">
            <div className="col-md-4">
              <div className="row">
                <div className="col p-0">
                  {showProgress ? (
                    <div className="uploadProgressBar">
                      <div className="progress mt-2" style={{ height: "10px" }}>
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated bg-danger"
                          role="progressbar"
                          aria-valuenow="75"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{ width: "100%", height: "10px" }}
                        ></div>
                      </div>
                      <p>
                        Uploading<span className="dot-animation"></span>
                      </p>
                    </div>
                  ) : (
                    <div className="modulepic justify-content-start">
                      <div className="thumbnailImageDiv">
                        {moduleDetails.thumbnail ? (
                          <div>
                            <img id="thumbnailImage" src={moduleDetails.thumbnail} alt="Uploaded Thumbnail" />
                            <span className="canceldelete" onClick={removeThumbnail}>
                              X
                            </span>
                          </div>
                        ) : (
                          <div className="fileuploader">
                            <FileUploader
                              handleChange={handleImageUpload}
                              name="thumbnailInput"
                              types={imageFileTypes}
                              label="drag & drop or choose file to upload"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="col imgupload">
                  <label className="mb-1">
                    Thumbnail Image <span> * </span>
                  </label>
                  <p className="recommend">Max file size: 100KB</p>
                  <p className="recommend">Required Resolution* (1280px &times; 720px)</p>
                  <p className="fileError">{fileError}</p>
                </div>
              </div>
              <div className="row mt-2">
                <div className="form-group ps-0">
                  <label>
                    Name <span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Enter name"
                    value={moduleDetails?.name}
                    onChange={(e) => setModuleDetails((prev) => ({ ...prev, name: e.target.value }))}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-8 mt-1">
              <div className="form-group">
                <label htmlFor="exampleFormControlDescription">Description </label>
                <div className="modalDescription mt-2">
                  <Editor
                    name="project_about"
                    id="exampleFormControlDescription"
                    editorState={editorState}
                    stripPastedStyles={true}
                    wrapperClassName="demo-wrapper"
                    className="mt-2"
                    editorClassName="demo-editor"
                    onEditorStateChange={handleEditorChange}
                    toolbar={{
                      options: ["inline", "remove", "history"],
                      inline: {
                        inDropdown: false,
                        options: ["bold", "italic", "underline", "strikethrough"],
                      },
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              {formLoading.basic ? (
                <div className="footerbtn text-end">
                  <button>
                    <SpinnerIcon />
                  </button>
                </div>
              ) : (
                <div className="footerbtn text-end">
                  <button onClick={handleSaveBasicDetails}>Save</button>
                </div>
              )}
            </div>
          </div>
          <div className="scenario-box">
            <div className="row scenario-box-child">
              <div className="collapsibleTable">
                <div className="tableItem">
                  <div className="switchHeadBtn">
                    <span
                      className={`arrow-btn ${showModuleInitialPoints ? "open" : "close"}`}
                      onClick={toggleInitialPointsVisibility}
                    >
                      <RightCollapseIcon />
                    </span>
                    <p>Module Initial Points</p>
                  </div>
                </div>
                <div className={`collapsibleItem ${showModuleInitialPoints ? "" : "hidden"}`}>
                  <div className="col-md-5 mb-3">
                    <div className="form-group">
                      <label>
                        Player Landing Position <span> * </span>
                      </label>
                      <Select
                        name="Object"
                        className="basic-multi-select mt-2"
                        classNamePrefix="select"
                        placeholder="Select Landing Position"
                        createNewCustomTags
                        value={playerSpot}
                        options={hotspotList}
                        onChange={(value) => {
                          !value ? setPlayerSpotError(true) : setPlayerSpotError(false);
                          setPlayerSpot(value);
                        }}
                      />
                      {playerSpotError && <p className="error">Please select an option</p>}
                    </div>
                  </div>
                  <DynamicModuleTable>
                    {initialization.map((item, index) => (
                      <KeyValueInput
                        key={item.id}
                        onAddClick={onAddButtonClick}
                        onRemoveClick={() => onRemoveClick(item.id)}
                        optionList={interactiveOptionList}
                        onChangeHandler={onChangeHandler}
                        inputData={item}
                        categoryMapping={interactiveAnimationMapping}
                        showAddButton={index === initialization.length - 1}
                        showRemoveButton={initialization.length > 1}
                        index={index}
                        showObjectTitle={true}
                        heading={index === 0 ? "" : ""}
                        errorData={formError[item.id]}
                      />
                    ))}
                  </DynamicModuleTable>
                </div>
              </div>
            </div>
          </div>

          <div className=" scenario-box">
            <div className="module-steps-header">
              <h6>Module Steps</h6>
              <div className="language-enable-control">
                <span className="language-enable-label">Enable languages</span>
                <div className="form-check form-switch language-enable-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="enableLanguageSelection"
                    checked={enableLanguageSelection}
                    onChange={(e) => {
                      setEnableLanguageSelection(e.target.checked)
                      setSelectedModuleLanguage(pre => e.target.checked ? pre : "english" )
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Language Selection Start */}
            {enableLanguageSelection && (
              <div className="language-selection-section">
                <div className="popupselect">
                  <p>Languages</p>
                  <div className="language-options">
                    <div className="radio-inputs">
                      {scenarioBuilderStepLanguages.map((language) => (
                        <label key={language.value} className="radio">
                          <input
                            type="radio"
                            name="moduleLanguage"
                            value={language.value}
                            checked={selectedModuleLanguage === language.value}
                            onChange={(e) => setSelectedModuleLanguage(e.target.value)}
                          />
                          <span className="name">{language.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Language Selection End */}






            {stepsList?.map((step, index) => {

              const showStepDetails = visibleSteps.includes(step.id);

              return (
                <>
                  <div className="switchHeadBtn">
                    <span
                      className={showStepDetails ? "arrow-btn open" : "arrow-btn close "}
                      onClick={() => toggleStepVisibility(step.id)}
                    >
                      <RightCollapseIcon />
                    </span>
                    <p>
                      {" "}
                      Step {index + 1} - {step.title}
                    </p>

                    {selectedModuleLanguage === "english" &&
                      <div className="action-btns">

                        <button className="add" onClick={() => onNewStepAddClick(index + 1)}>
                          Add Below
                        </button>

                        {stepsList?.length > 1 && (
                          <button className="remove" onClick={() => onRemoveStepsClick(step.id)}>
                            Remove
                          </button>
                        )}

                      </div>
                    }

                  </div>
                  <React.Fragment key={step.id}>
                    {showStepDetails && (

                      <div className="scenario-box-item step-child">
                        <div className="row scenario-box-child">
                          <div className="row">

                            <div className="col-md-6">
                              <div className="form-group ps-0">
                                <label>
                                  Step Title <span> * </span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control mt-2"
                                  placeholder="Enter name"
                                  value={step.title}
                                  onChange={(e) => stepsChangeHandler(step.id, "title", e.target.value)}
                                />
                                {formError?.[step.id]?.title && <p className="error pb-2">Title can not be empty</p>}
                              </div>
                            </div>

                            {selectedModuleLanguage === "english" &&
                              <>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label>End Position</label>
                                    <Select
                                      name="Object"
                                      className="basic-multi-select mt-2"
                                      classNamePrefix="select"
                                      placeholder="Select End Position"
                                      createNewCustomTags
                                      value={step.targetLocation}
                                      options={hotspotList}
                                      onChange={(value) => stepsChangeHandler(step.id, "targetLocation", value)}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6 mt-3">
                                  <div className="form-group">
                                    <label>
                                      Select Type <span> * </span>
                                    </label>
                                    <Select
                                      name="Object"
                                      className="basic-multi-select mt-2"
                                      classNamePrefix="select"
                                      placeholder="Select Type"
                                      createNewCustomTags
                                      options={stepTypeOptions}
                                      value={step.type}
                                      onChange={(value) => stepsChangeHandler(step.id, "type", value)}
                                    />
                                    {formError?.[step.id]?.type && <p className="error mb-2">Please select the type</p>}
                                  </div>
                                </div>

                                {step?.type?.value && (
                                  <div className="col-md-6">
                                    <>
                                      {/* <p>{step.type?.label}</p> */}
                                      {step?.type?.value === "POPUP_WITH_BUTTON" && (
                                        <div className="form-group mt-3">
                                          <label>
                                            Button Name <span> * </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="Enter name"
                                            value={step.popupButton}
                                            onChange={(e) => stepsChangeHandler(step.id, "popupButton", e.target.value)}
                                          />
                                          {formError?.[step.id]?.popupButton && (
                                            <p className="error">Button name can not be empty</p>
                                          )}
                                        </div>
                                      )}
                                      {step?.type?.value === "POPUP_WITH_TIMER" && (
                                        <div className="form-group mt-3">
                                          <label>
                                            Popup Duration <span> * </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="Enter name"
                                            value={step.popupDuration}
                                            onChange={(e) => stepsChangeHandler(step.id, "popupDuration", e.target.value)}
                                          />
                                          {formError?.[step.id]?.popupDuration && (
                                            <p className="error">Popup duration can not be empty</p>
                                          )}
                                        </div>
                                      )}
                                    </>
                                  </div>
                                )}

                                <div className="col-md-6 mt-3">
                                  <div className="form-group">
                                    <label>Add Action</label>
                                    <Select
                                      name="Object"
                                      className="basic-multi-select mt-2"
                                      classNamePrefix="select"
                                      placeholder="Select Add Action"
                                      options={addActionOptions}
                                      value={step.actionType}
                                      onChange={(value) => stepsChangeHandler(step.id, "actionType", value)}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6 mt-3">
                                  {step.actionType?.value === "TELEPORT" && (
                                    <div className="form-group">
                                      <label>Player Landing Position</label>
                                      <Select
                                        name="Object"
                                        className="basic-multi-select mt-2"
                                        classNamePrefix="select"
                                        placeholder="Select Player Landing Position"
                                        createNewCustomTags
                                        value={step.playerLandingPosition}
                                        options={hotspotList}
                                        onChange={(value) => stepsChangeHandler(step.id, "playerLandingPosition", value)}
                                      />
                                    </div>
                                  )}
                                </div>
                              </>
                            }

                            <div className="col-md-6 mt-3">
                              <div className="form-group">
                                <label>Upload Voice Over</label>
                                <div className="DragDropMenu uploadfilesss mt-2 at-scenario">

                                  {!step?.voice?.voiceover
                                    ?
                                    <div className="fileuploader">
                                      <FileUploader
                                        handleChange={(file) => handleVoiceOverUpload(step.id, file)}
                                        label={step?.voice?.filename ? "drag & drop or choose file to upload" : ""}
                                        name="voiceOver"
                                        types={voiceOverFileTypes}
                                      >
                                        <span className="upload-box-info">
                                          drag & drop or choose only audio file to upload
                                        </span>
                                      </FileUploader>
                                    </div>
                                    :
                                    <div className="uploadstatus mt-0">
                                      <div className="uploadstatus">
                                        <div className="upperdiv">
                                          <div className="uploaddata">
                                            <div className="xr">
                                              <p>{step?.voice?.filename}</p>
                                              <p
                                                style={{ cursor: "pointer", lineHeight: "1" }}
                                                onClick={() => handleVoiceOverRemove(step.id)}
                                              >
                                                <i className="bi bi-x-circle-fill"></i>
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }

                                  {step?.voice?.file && !step?.voice?.voiceover && (
                                    <div className="uploadstatus mt-0">
                                      <div className="uploadstatus">
                                        <div className="upperdiv">
                                          <div className="uploaddata">
                                            <div className="xr">
                                              <p>{step.voice.filename}</p>
                                              <p
                                                style={{ cursor: "pointer", lineHeight: "1" }}
                                                onClick={() => handleVoiceOverRemove(step.id)}
                                              >
                                                <i className="bi bi-x-circle-fill"></i>
                                              </p>
                                            </div>
                                            <div className="xr mb-1">
                                              <p className="filesize">{formatFileSize(step.voice.file.size)}</p>
                                              <p className="filesize">{step.voice.progress}%</p>
                                            </div>
                                            <Progress completed={step.voice.progress} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                </div>
                              </div>
                            </div>

                            <div className="col-md-6 mt-3">
                              <div className="form-group">
                                <label>Upload Image</label>
                                <div className="DragDropMenu uploadfilesss mt-2 at-scenario">

                                  {!step?.image?.imagePath
                                    ?
                                    <div className="fileuploader">
                                      <FileUploader
                                        handleChange={(file) => handleStepImageUpload(step.id, file)}
                                        label={step?.image?.filename ? "drag & drop or choose file to upload" : ""}
                                        name="image"
                                        types={imageOverFileTypes}
                                      >
                                        <span className="upload-box-info">
                                          drag & drop or choose only image file to upload
                                        </span>
                                      </FileUploader>
                                    </div>
                                    :
                                    <div className="uploadstatus mt-0">
                                      <div className="uploadstatus">
                                        <div className="upperdiv">
                                          <div className="uploaddata">
                                            <div className="xr">
                                              <p>{step?.image?.filename}</p>
                                              <p
                                                style={{ cursor: "pointer", lineHeight: "1" }}
                                                onClick={() => handleImageRemove(step.id)}
                                              >
                                                <i className="bi bi-x-circle-fill"></i>
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }

                                  {step?.image?.file && !step?.image?.imagePath && (
                                    <div className="uploadstatus mt-0">
                                      <div className="uploadstatus">
                                        <div className="upperdiv">
                                          <div className="uploaddata">
                                            <div className="xr">
                                              <p>{step.image.filename}</p>
                                              <p
                                                style={{ cursor: "pointer", lineHeight: "1" }}
                                                onClick={() => handleImageRemove(step.id)}
                                              >
                                                <i className="bi bi-x-circle-fill"></i>
                                              </p>
                                            </div>
                                            <div className="xr mb-1">
                                              <p className="filesize">{formatFileSize(step.image.file.size)}</p>
                                              <p className="filesize">{step.image.progress}%</p>
                                            </div>
                                            <Progress completed={step.image.progress} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                </div>
                              </div>
                            </div>

                            <div className="col-md-6 mt-3 mb-3">
                              <div className="form-group ps-0">
                                <label>
                                  Step Initial Message <span> * </span>
                                </label>

                                <textarea
                                  className="form-control mt-2"
                                  value={step.message}
                                  onChange={(e) => stepsChangeHandler(step.id, "message", e.target.value)}
                                />
                              </div>
                            </div>

                          </div>
                        </div>




                        {selectedModuleLanguage === "english" &&
                          <div className="row scenario-box-child">
                            <div className="collapsibleTable">
                              <div className="tableItem">
                                <div className="switchHeadBtn">
                                  <span
                                    className={`arrow-btn ${visibleStepComponents?.[step.id]?.conditions ? "open" : "close"
                                      }`}
                                    onClick={() => toggleStepComponentsVisibility(step.id, "conditions")}
                                  >
                                    <RightCollapseIcon />
                                  </span>
                                  <p>Initial Conditions</p>
                                </div>
                              </div>
                              <div
                                className={`collapsibleItem ${visibleStepComponents?.[step.id]?.conditions ? "" : "hidden"
                                  }`}
                              >
                                <DynamicModuleTable>
                                  {step.conditions.map((condition, conditionIndex) => {
                                    return (
                                      <KeyValueInput
                                        key={condition.id}
                                        showAddButton={step.conditions.length - 1 === conditionIndex}
                                        showRemoveButton={step.conditions.length > 1}
                                        showObjectTitle={false}
                                        optionList={interactiveOptionList}
                                        inputData={condition}
                                        categoryMapping={interactiveAnimationMapping}
                                        onChangeHandler={(id, key, value, valueType, valueObjectKey) =>
                                          handleStepsChange(
                                            "conditions",
                                            step.id,
                                            id,
                                            key,
                                            value,
                                            valueType,
                                            valueObjectKey
                                          )
                                        }
                                        onAddClick={() => handleAddInitialCondition(step.id)}
                                        onRemoveClick={() => handleRemoveInitialCondition(step.id, condition.id)}
                                        index={conditionIndex}
                                        heading={conditionIndex === 0 ? "Initial Condition" : ""}
                                        errorData={formError[condition.id]}
                                      />
                                    );
                                  })}
                                </DynamicModuleTable>
                              </div>
                            </div>
                          </div>
                        }

                        <div className="row scenario-box-child">
                          <div className="row scenario-box-child">
                            <div className="collapsibleTable">
                              <div className="tableItem">
                                <div className="switchHeadBtn">
                                  <span className={`arrow-btn ${visibleStepComponents?.[step.id]?.onTarget ? "open" : "close"}`}
                                    onClick={() => toggleStepComponentsVisibility(step.id, "onTarget")} >
                                    <RightCollapseIcon />
                                  </span>
                                  <p>On Target Triggers</p>
                                </div>
                              </div>

                              <div className={`collapsibleItem ${visibleStepComponents?.[step.id]?.onTarget ? "" : "hidden"}`} >
                                <div className="col-md-5 mb-3">
                                  <div className="form-group ps-0">
                                    <label>On Trigger Message</label>
                                    <input
                                      type="text"
                                      className="form-control mt-2"
                                      placeholder="Enter Message"
                                      value={step.onTargetMessage}
                                      onChange={(e) => stepsChangeHandler(step.id, "onTargetMessage", e.target.value)}
                                    />
                                  </div>
                                </div>

                                {selectedModuleLanguage === "english" &&
                                  <DynamicModuleTable>
                                    {step.onTarget.map((target, targetIndex) => {
                                      return (
                                        <KeyValueInput
                                          key={target.id}
                                          showAddButton={step.onTarget.length - 1 === targetIndex}
                                          showRemoveButton={step.onTarget.length > 1}
                                          showObjectTitle={true}
                                          optionList={interactiveOptionList}
                                          inputData={target}
                                          categoryMapping={interactiveAnimationMapping}
                                          onChangeHandler={(id, key, value, valueType, valueObjectKey) =>
                                            handleStepsChange(
                                              "onTarget",
                                              step.id,
                                              id,
                                              key,
                                              value,
                                              valueType,
                                              valueObjectKey
                                            )
                                          }
                                          onAddClick={() => handleAddOnTarget(step.id)}
                                          onRemoveClick={() => handleRemoveOnTarget(step.id, target.id)}
                                          index={targetIndex}
                                          errorData={formError[target.id]}
                                        />
                                      );
                                    })}
                                  </DynamicModuleTable>
                                }

                              </div>
                            </div>
                          </div>
                        </div>

                        {selectedModuleLanguage === "english" &&
                          <>
                            <div className="row scenario-box-child">
                              <div className="collapsibleTable">
                                <div className="tableItem">
                                  <div className="switchHeadBtn">
                                    <span
                                      className={`arrow-btn ${visibleStepComponents?.[step.id]?.stepEnd ? "open" : "close"
                                        }`}
                                      onClick={() => toggleStepComponentsVisibility(step.id, "stepEnd")}
                                    >
                                      <RightCollapseIcon />
                                    </span>
                                    <p>Step End Conditions</p>
                                  </div>
                                </div>
                                <div
                                  className={`collapsibleItem ${visibleStepComponents?.[step.id]?.stepEnd ? "" : "hidden"}`}
                                >
                                  <DynamicModuleTable>
                                    {step.stepEnd.map((stepEnd, stepEndIndex) => {
                                      return (
                                        <KeyValueInput
                                          key={stepEnd.id}
                                          showAddButton={step.stepEnd.length - 1 === stepEndIndex}
                                          showRemoveButton={step.stepEnd.length > 1}
                                          showObjectTitle={false}
                                          optionList={interactiveOptionList}
                                          inputData={stepEnd}
                                          categoryMapping={interactiveAnimationMapping}
                                          onChangeHandler={(id, key, value, valueType, valueObjectKey) =>
                                            handleStepsChange("stepEnd", step.id, id, key, value, valueType, valueObjectKey)
                                          }
                                          onAddClick={() => handleAddStepEnd(step.id)}
                                          onRemoveClick={() => handleRemoveStepEnd(step.id, stepEnd.id)}
                                          index={stepEndIndex}
                                          heading={stepEndIndex === 0 ? "Step End Condition" : ""}
                                          errorData={formError[stepEnd.id]}
                                        />
                                      );
                                    })}
                                  </DynamicModuleTable>
                                </div>
                              </div>
                            </div>

                            <div className="row scenario-box-child">
                              <div className="collapsibleTable">
                                <div className="tableItem">
                                  <div className="switchHeadBtn">
                                    <span
                                      className={`arrow-btn ${visibleStepComponents?.[step.id]?.endResults ? "open" : "close"
                                        }`}
                                      onClick={() => toggleStepComponentsVisibility(step.id, "endResults")}
                                    >
                                      <RightCollapseIcon />
                                    </span>
                                    <p>End Results</p>
                                  </div>
                                </div>
                                <div
                                  className={`collapsibleItem ${visibleStepComponents?.[step.id]?.endResults ? "" : "hidden"
                                    }`}
                                >
                                  <DynamicModuleTable>
                                    {step.endResults.map((endResult, endResultIndex) => {
                                      return (
                                        <KeyValueInput
                                          key={endResult.id}
                                          showAddButton={step.endResults.length - 1 === endResultIndex}
                                          showRemoveButton={step.endResults.length > 1}
                                          showObjectTitle={false}
                                          optionList={interactiveOptionList}
                                          inputData={endResult}
                                          categoryMapping={interactiveAnimationMapping}
                                          onChangeHandler={(id, key, value, valueType, valueObjectKey) =>
                                            handleStepsChange(
                                              "endResults",
                                              step.id,
                                              id,
                                              key,
                                              value,
                                              valueType,
                                              valueObjectKey
                                            )
                                          }
                                          onAddClick={() => handleAddEndResult(step.id)}
                                          onRemoveClick={() => handleRemoveEndResult(step.id, endResult.id)}
                                          index={endResultIndex}
                                          heading={endResultIndex === 0 ? "End Results" : ""}
                                          errorData={formError[endResult.id]}
                                        />
                                      );
                                    })}
                                  </DynamicModuleTable>
                                </div>
                              </div>
                            </div>
                          </>
                        }

                      </div>

                    )}

                  </React.Fragment >
                </>
              );
            })}


            <div className="row">
              <div className="col-12">
                {formLoading.steps ? (
                  <div className="footerbtn text-end justify-content-end mt-3">
                    <button>
                      <SpinnerIcon />
                    </button>
                  </div>
                ) : (
                  <div className="footerbtn text-end justify-content-end mt-3">
                    <button onClick={handleSaveStepsAndInitialization}>Save</button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default AddDynamicModule;
